<template>
    <div class="row cart_upsell">
        <div class="col-md-6 interested-product-item" v-for="linkedProduct in cartLinkedProducts">
            <div class="cat-product">
                <div class="products_item">
                    <div class="product-thumbnail-box position-relative">
                        <span v-if="labels(linkedProduct)['text_image_top_right']" class="label-text-top-right position-absolute font-weight-bold text-center">{{ labels(linkedProduct)['text_image_top_right'].text }}</span>
                        <span v-if="labels(linkedProduct)['text_image_top_left']" class="label-text-top-left position-absolute font-weight-bold text-center">{{ labels(linkedProduct)['text_image_top_left'].text }}</span>
                        <span v-if="labels(linkedProduct)['text_image_bottom_right']" class="label-text-bottom-right position-absolute font-weight-bold text-center">{{ labels(linkedProduct)['text_image_bottom_right'].text }}</span>
                        <span v-if="labels(linkedProduct)['text_image_bottom_left']" class="label-text-bottom-left position-absolute font-weight-bold text-center">{{ labels(linkedProduct)['text_image_bottom_left'].text }}</span>

                        <div class="position-relative">
                            <a class="product-category-img-a"  :href="linkedProduct.publish_url">
                                <wrap-image class="bs_img" :prop-image="linkedProduct.main_image || []"></wrap-image>
                            </a>
                            <div v-if="labels(linkedProduct)['image_image_top_left']" class="product-img-berocket-label-user-image top_left position-absolute">
                                <wrap-image :prop-image="labels(linkedProduct)['image_image_top_left'].image"></wrap-image>
                            </div>
                            <div v-if="labels(linkedProduct)['image_image_top_right']" class="product-img-berocket-label-user-image top_right position-absolute">
                                <wrap-image :prop-image="labels(linkedProduct)['image_image_top_right'].image"></wrap-image>
                            </div>
                            <div v-if="labels(linkedProduct)['image_image_bottom_left']" class="product-img-berocket-label-user-image bottom_left position-absolute">
                                <wrap-image :prop-image="labels(linkedProduct)['image_image_bottom_left'].image"></wrap-image>
                            </div>
                            <div v-if="labels(linkedProduct)['image_image_bottom_right']" class="product-img-berocket-label-user-image bottom_right position-absolute">
                                <wrap-image :prop-image="labels(linkedProduct)['image_image_bottom_right'].image"></wrap-image>
                            </div>
                        </div>
                        <p v-if="linkedProduct.stock_status !== 'in_stock'" class="unavailable_txt">Currently Unavailable</p>
                        <div v-if="labels(linkedProduct)['text_label_bottom_left']" class="in-stock-box text-uppercase text-center">
                            <span>{{labels(linkedProduct)['text_label_bottom_left'].text}}</span>
                        </div>
                        <div v-if="labels(linkedProduct)['text_label_bottom_right']" class="in-stock-box in-stock-box-right text-uppercase text-center">
                            <span>{{labels(linkedProduct)['text_label_bottom_right'].text}}</span>
                        </div>    
                    </div>
                    <a class="tn_btn_light details_btn" :href="linkedProduct.publish_url">Details &amp; Pricing</a>
                    <h2 class="product__title">{{linkedProduct.title}}</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import WrapImage from "../WrapImage";


export default {
    name: 'cart-product-list-item',
    components: {WrapImage},

    data(){
        return {
        }
    },
    computed: {
        ...mapGetters(['cartLinkedProducts']),

    },
    methods:
    {
        labels(linkedProduct) {
             let labels = []

            if (!linkedProduct.labels.length) {
                return labels
            }

            for(let i = 0; i < linkedProduct.labels.length; i++){
                const label = linkedProduct.labels[i]
                labels[label.content_type + '_' + label.position_type + '_' + label.position] = label
            }
            return labels;
        }
    }
}
</script>

<style>
.products_item { margin-bottom: 2.992em;}
.products_item .product__title {
    line-height: 20px;
    padding: 0.5em 0;
    font-size: 14px;
    color: #9daca1;
    font-family: 'scalasansbold', sans-serif;
}
.products_item p.unavailable_txt {
    font-family: scalasansbold, sans-serif !important;
    text-transform: capitalize;
    background-color: #b14747;
    padding: 6px 10px 3px;
    width: fit-content;
    border-radius: 3px;
    min-height: 25px;
    margin-top: 10px;
    font-weight: 600;
    line-height: 21px;
    font-size: 14px;
    color: #fff;
}
.products_item .product-category-img-a img  {
    width: 230px;
    height: auto;
    max-width: 100%;
}
.product-thumbnail-box .label-text-top-right {
    font-family: 'scalasansbold', sans-serif;
    background-color: #b14747;
    width: fit-content;
    border-radius: 3px;
    line-height: 25px;
    font-size: 14px;
    padding: 0 7px;
    right: -10px;
    color: #fff;
    z-index: 1;
    top: -10px;
}

.product-thumbnail-box .label-text-top-left {
    font-family: 'scalasansbold', sans-serif;
    background-color: #b14747;
    width: fit-content;
    border-radius: 3px;
    line-height: 25px;
    font-size: 14px;
    padding: 0 7px;
    left: -10px;
    color: #fff;
    z-index: 1;
    top: -10px;
}

.product-thumbnail-box .label-text-bottom-right {
    font-family: 'scalasansbold', sans-serif;
    background-color: #b14747;
    width: fit-content;
    border-radius: 3px;
    line-height: 25px;
    font-size: 14px;
    padding: 0 7px;
    right: -10px;
    color: #fff;
    z-index: 1;
    bottom: -10px;
}

.product-thumbnail-box .label-text-bottom-left {
    font-family: 'scalasansbold', sans-serif;
    background-color: #b14747;
    width: fit-content;
    border-radius: 3px;
    line-height: 25px;
    font-size: 14px;
    padding: 0 7px;
    left: -10px;
    color: #fff;
    z-index: 1;
    bottom: -10px;
}
.product-thumbnail-box .in-stock-box {
    font-family: scalasansbold, sans-serif !important;
    background-color: #b14747;
    margin-top: 15px;
    margin-bottom: 0;
    padding: 0 12px;
    width: fit-content;
    border-radius: 3px;
    line-height: 25px;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    height: 30px;
    display: flex;
    align-items: center;
}
.product-thumbnail-box .in-stock-box.in-stock-box-right {
    float: right;
}
.product-thumbnail-box .product-img-berocket-label-user-image { bottom: 10px; width: 60px; }
.product-thumbnail-box .product-img-berocket-label-user-image.bottom_left { left: 10px }
.product-thumbnail-box .product-img-berocket-label-user-image.bottom_right { right: 10px }
.product-thumbnail-box .product-img-berocket-label-user-image.top_left { top: 10px; left: 10px }
.product-thumbnail-box .product-img-berocket-label-user-image.top_right { top: 10px; right: 10px }
.product-thumbnail-box .product-img-berocket-label-user-image .wrap-image { margin-bottom: 0; }
.product-thumbnail-box .product-img-berocket-label-user-image img { box-shadow: unset !important; }
.cart_interested_sec.page-second-title {
    margin-bottom: 20px !important;
}
.interested-product-item{
    max-width:230px;
}
</style>
